import { useEffect, useRef, useState } from 'react';

const PLAY_URL  = 'https://play.google.com/store/apps/details?id=com.nursingprometric';
const APPLE_URL = 'https://apps.apple.com/eg/app/nursing-prometric/id6657985535';
const APP_ICON  = '/logo.png';

const SCREENSHOTS = [
  'https://play-lh.googleusercontent.com/Asbdtdsm30wKqSS5eQj9CmZt1_TKA-ROaxXQYqc7i-M8vfhSM96upKPXWOiXM3cc51Exw3prvpLmvKHSqRNNzQ=w2560-h1440-rw',
  'https://play-lh.googleusercontent.com/tVon-XmoFsPd7hL1gx7wW2s5MEcopXqX8NM02GFaaHzpZeBGnupUw2jMz3sILQpP-L2Duh8936vUpYE7nPPDog=w2560-h1440-rw',
  'https://play-lh.googleusercontent.com/9Oxh_6o-MuQMzB4mv2TCTzzlqxa9YCYSotprDAsvAz7Ux2KftBW1Trkfv-uKYBQi2QZN3_3oUod499QtSNF1=w2560-h1440-rw',
  'https://play-lh.googleusercontent.com/uLl9LxkDNOv8mTjl5j3_ZKjs62VxtlM8_VRguZW6gacCS-L2ipZX99YfoRonuFN5rcOn9bqAAaL2ju5PzarO2g=w2560-h1440-rw',
];

const categories = [
  { gradient: 'linear-gradient(135deg,#249E94,#1a7a6f)', icon: '👩‍⚕️', en: 'Nursing Specialist',    ar: 'أخصائي تمريض' },
  { gradient: 'linear-gradient(135deg,#4169E1,#2a4fc7)', icon: '🧑‍⚕️', en: 'Medical Assistant',     ar: 'فني تمريض' },
  { gradient: 'linear-gradient(135deg,#D94040,#b52e2e)', icon: '🚑',   en: 'Emergency Technician',  ar: 'فني خدمات طبية عاجلة' },
  { gradient: 'linear-gradient(135deg,#7B4FD4,#5e38a8)', icon: '🔬',   en: 'Laboratory Technician', ar: 'فني مختبرات طبية' },
];

const features = [
  { color: '#249E94', icon: '📚', title: 'Question Bank',     desc: '1000+ exam-style questions across all prometric domains.' },
  { color: '#249E94', icon: '📝', title: 'Mock Exams',        desc: 'Timed full-length tests that simulate the real Prometric experience.' },
  { color: '#249E94', icon: '📄', title: 'PDF Resources',     desc: 'Official study guides and reference docs, available offline.' },
  { color: '#249E94', icon: '📊', title: 'Score Tracking',    desc: 'See your results and identify weak areas to target your study.' },
  { color: '#249E94', icon: '📡', title: 'Study Channels',    desc: 'Join the nursing community and access the latest exam updates.' },
  { color: '#249E94', icon: '🌍', title: 'Bilingual EN / AR', desc: 'Full English and Arabic support for learners across the region.' },
];

const reviews = [
  { name: 'Sobia Akhter',     stars: 5, text: 'Excellent — thanks for the great information and resources!' },
  { name: 'Mostafa El-Zayat',stars: 5, text: 'Completely excellent. Really helped me prepare for my exam.' },
  { name: 'Ahmed Hassan',     stars: 5, text: 'The best prometric prep app available. Clean and easy to use.' },
];

/* ─────────── CSS ─────────── */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --green:#249E94;--green2:#1a7a6f;
  --blue:#4169E1;--red:#D94040;--purple:#7B4FD4;
  --text:#111827;--muted:#6B7280;
  --bg:#F6F8FA;--white:#ffffff;--border:#E5E7EB;
  --r:16px;
}
html{scroll-behavior:smooth}
body{font-family:'Plus Jakarta Sans',sans-serif;background:var(--white);color:var(--text);overflow-x:hidden;margin:0}

/* ── NAV ── */
.lp-nav{
  position:fixed;top:0;left:0;right:0;z-index:200;height:64px;
  background:rgba(255,255,255,0.97);backdrop-filter:blur(12px);
  border-bottom:1px solid var(--border);
  display:flex;align-items:center;justify-content:space-between;padding:0 5vw;
}
.lp-brand{display:flex;align-items:center;gap:10px;font-weight:800;font-size:1.1rem;color:var(--text);text-decoration:none;flex-shrink:0}
.lp-brand img{width:36px;height:36px;border-radius:10px;object-fit:cover}
.lp-brand span{color:var(--green)}
.lp-nav-links{display:flex;gap:2rem;list-style:none;align-items:center}
.lp-nav-links a{color:var(--muted);text-decoration:none;font-size:.9rem;font-weight:500;transition:color .2s}
.lp-nav-links a:hover{color:var(--green)}
.lp-dl-btn{
  background:var(--green);color:#fff;
  padding:.5rem 1.4rem;border-radius:2rem;
  font-weight:700;font-size:.88rem;text-decoration:none;
  display:flex;align-items:center;gap:.4rem;white-space:nowrap;
  transition:background .2s,transform .15s;flex-shrink:0;
}
.lp-dl-btn:hover{background:var(--green2);transform:translateY(-1px)}

/* Hamburger */
.lp-burger{
  display:none;flex-direction:column;justify-content:center;align-items:center;
  width:40px;height:40px;background:none;border:none;cursor:pointer;gap:5px;padding:4px;
}
.lp-burger span{display:block;width:22px;height:2px;background:var(--text);border-radius:2px;transition:transform .3s,opacity .3s}
.lp-burger.open span:nth-child(1){transform:translateY(7px) rotate(45deg)}
.lp-burger.open span:nth-child(2){opacity:0}
.lp-burger.open span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}

/* Mobile drawer */
.lp-mobile-menu{
  display:none;position:fixed;top:64px;left:0;right:0;z-index:199;
  background:#fff;border-bottom:1px solid var(--border);
  flex-direction:column;padding:1rem 5vw 1.5rem;gap:.2rem;
  box-shadow:0 8px 24px rgba(0,0,0,0.08);
}
.lp-mobile-menu.open{display:flex}
.lp-mobile-menu a{
  color:var(--text);text-decoration:none;font-size:1rem;font-weight:600;
  padding:.75rem .5rem;border-bottom:1px solid var(--border);transition:color .2s;
}
.lp-mobile-menu a:last-child{border-bottom:none}
.lp-mobile-menu a:hover{color:var(--green)}
.lp-mobile-dl{
  margin-top:.8rem;background:var(--green);color:#fff !important;
  text-align:center;padding:.9rem !important;border-radius:12px;font-size:1rem;font-weight:700 !important;
  border-bottom:none !important;
}
.lp-mobile-dl:hover{background:var(--green2) !important}

/* ── HERO ── */
.lp-hero{
  padding:100px 5vw 80px;
  background:linear-gradient(160deg,#f0faf8 0%,#ffffff 55%);
  position:relative;overflow:hidden;
}
.lp-hero::before{
  content:'';position:absolute;top:-120px;right:-100px;
  width:480px;height:480px;border-radius:50%;
  background:radial-gradient(circle,rgba(36,158,148,0.1) 0%,transparent 70%);
  pointer-events:none;
}
.lp-hero-inner{
  max-width:1180px;margin:0 auto;
  display:grid;grid-template-columns:1fr 1fr;gap:4rem;align-items:center;
}
.lp-tag{
  display:inline-flex;align-items:center;gap:.5rem;
  background:rgba(36,158,148,0.1);border:1px solid rgba(36,158,148,0.25);
  color:var(--green);border-radius:2rem;padding:.3rem .9rem;
  font-size:.78rem;font-weight:600;margin-bottom:1.2rem;
  animation:lpUp .5s ease both;
}
.lp-hero h1{font-size:clamp(2.2rem,4.5vw,3.8rem);font-weight:800;line-height:1.1;animation:lpUp .5s .08s ease both}
.lp-hero h1 span{color:var(--green)}
.lp-hero-ar{font-size:1.1rem;color:var(--muted);font-weight:500;margin-top:.4rem;direction:rtl;animation:lpUp .5s .12s ease both}
.lp-hero-desc{margin-top:1.2rem;color:var(--muted);font-size:1rem;line-height:1.75;max-width:48ch;animation:lpUp .5s .16s ease both}

/* Hero store buttons */
.lp-hero-actions{margin-top:2rem;display:flex;gap:.9rem;flex-wrap:wrap;animation:lpUp .5s .2s ease both}
.lp-hero-store-btn{
  display:inline-flex;align-items:center;gap:.7rem;
  padding:.75rem 1.4rem;border-radius:12px;text-decoration:none;
  font-weight:700;font-size:.92rem;
  transition:transform .2s,box-shadow .2s;
}
.lp-hero-store-btn.android{
  background:var(--green);color:#fff;
  box-shadow:0 4px 16px rgba(36,158,148,0.3);
}
.lp-hero-store-btn.android:hover{background:var(--green2);transform:translateY(-2px);box-shadow:0 8px 28px rgba(36,158,148,0.4)}
.lp-hero-store-btn.apple{
  background:#111827;color:#fff;
  box-shadow:0 4px 16px rgba(0,0,0,0.15);
}
.lp-hero-store-btn.apple:hover{background:#000;transform:translateY(-2px);box-shadow:0 8px 28px rgba(0,0,0,0.25)}
.lp-hero-store-sub{font-size:.6rem;font-weight:400;opacity:.75;display:block;line-height:1}
.lp-hero-store-name{display:block;line-height:1.3}

.lp-stats{margin-top:2.5rem;display:flex;gap:2rem;flex-wrap:wrap;animation:lpUp .5s .25s ease both}
.lp-stat-v{font-size:1.6rem;font-weight:800}
.lp-stat-l{font-size:.8rem;color:var(--muted);font-weight:500;margin-top:.1rem}

/* ── PHONE ── */
.lp-phone-wrap{position:relative;display:flex;justify-content:center;align-items:center;animation:lpFade .7s .2s ease both}
.lp-phone-frame{
  width:250px;background:#111;border-radius:44px;padding:10px;
  box-shadow:0 30px 80px rgba(0,0,0,0.22),0 0 0 1px rgba(255,255,255,0.07);
  position:relative;z-index:2;
}
.lp-phone-screen{border-radius:36px;overflow:hidden;background:#fff}
.lp-ph-header{background:linear-gradient(135deg,#249E94,#1a7a6f);padding:20px 16px 22px;position:relative;overflow:hidden}
.lp-ph-header::after{content:'';position:absolute;bottom:-28px;right:-28px;width:90px;height:90px;border-radius:50%;background:rgba(255,255,255,0.1)}
.lp-ph-header h3{color:#fff;font-size:.95rem;font-weight:800}
.lp-ph-header p{color:rgba(255,255,255,.85);font-size:.65rem;margin-top:.3rem;direction:rtl}
.lp-ph-body{padding:14px 12px;background:#f6f8fa;overflow-y:auto;max-height:calc(100% - 60px)}
.lp-ph-welcome-card{background:#fff;border-radius:14px;padding:14px;margin-bottom:12px;box-shadow:0 2px 8px rgba(0,0,0,.08)}
.lp-ph-welcome-title{font-size:.85rem;font-weight:800;color:var(--text);margin-bottom:.4rem;direction:rtl}
.lp-ph-welcome-text{font-size:.7rem;color:#6B7280;line-height:1.5;direction:rtl;margin:0}
.lp-ph-cat-label{font-size:.75rem;font-weight:700;color:var(--text);margin:10px 0 8px 0;direction:rtl}
.lp-ph-categories{display:flex;flex-direction:column;gap:8px}
.lp-ph-category-card{background:#fff;border-radius:12px;padding:12px;display:flex;align-items:center;gap:10px;box-shadow:0 1px 4px rgba(0,0,0,.06);transition:transform .2s,box-shadow .2s}
.lp-ph-category-card:active{transform:scale(0.98)}
.lp-ph-cat-icon{width:40px;height:40px;border-radius:50%;background:rgba(36,158,148,0.1);display:flex;align-items:center;justify-content:center;font-size:1.2rem;flex-shrink:0}
.lp-ph-cat-text{flex:1;min-width:0}
.lp-ph-cat-ar{font-size:.75rem;font-weight:700;color:var(--text);direction:rtl}
.lp-ph-cat-en{font-size:.65rem;color:#9CA3AF;margin-top:.2rem;direction:ltr}
.lp-ph-bottom-buttons{display:flex;gap:8px;margin-top:12px;padding-top:8px;border-top:1px solid #E5E7EB}
.lp-ph-btn{flex:1;padding:10px 12px;border:none;border-radius:10px;font-size:.72rem;font-weight:700;cursor:pointer;transition:transform .2s,box-shadow .2s;color:#fff;direction:rtl}
.lp-ph-btn-primary{background:linear-gradient(135deg,#249E94,#1a7a6f);box-shadow:0 2px 6px rgba(36,158,148,.2)}
.lp-ph-btn-primary:active{transform:scale(0.96)}
.lp-ph-btn-secondary{background:linear-gradient(135deg,#1a9a8a,#157570);box-shadow:0 2px 6px rgba(26,154,138,.2)}
.lp-ph-btn-secondary:active{transform:scale(0.96)}
.lp-ph-whitebox{background:#fff;border-radius:10px;padding:10px 12px;margin-bottom:10px;box-shadow:0 1px 6px rgba(0,0,0,.06)}
.lp-ph-wbt{font-size:.68rem;font-weight:700}
.lp-ph-wbar{font-size:.58rem;color:#6B7280;margin-top:2px;direction:rtl}
.lp-ph-label{font-size:.62rem;font-weight:700;color:var(--text);margin-bottom:7px}
.lp-ph-card{border-radius:11px;padding:10px 11px;display:flex;align-items:center;gap:9px;margin-bottom:7px}
.lp-ph-icon{width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.25);display:flex;align-items:center;justify-content:center;font-size:.95rem;flex-shrink:0}
.lp-ph-ct{flex:1}
.lp-ph-cen{color:#fff;font-size:.68rem;font-weight:700}
.lp-ph-car{color:rgba(255,255,255,.75);font-size:.56rem;margin-top:1px;direction:rtl}
.lp-ph-arr{width:22px;height:22px;border-radius:50%;background:rgba(255,255,255,.25);display:flex;align-items:center;justify-content:center;color:#fff;font-size:.68rem}
.lp-float{
  position:absolute;background:#fff;border-radius:12px;padding:.55rem .85rem;
  box-shadow:0 8px 28px rgba(0,0,0,0.1);display:flex;align-items:center;gap:.5rem;
  font-size:.76rem;font-weight:600;z-index:3;
}
.lp-float-1{bottom:30px;left:-20px;animation:lpFloat 3.5s ease-in-out infinite}
.lp-float-2{top:50px;right:-10px;animation:lpFloat 3.5s 1.8s ease-in-out infinite}
.lp-fdot{width:8px;height:8px;border-radius:50%;flex-shrink:0}

/* ── SECTIONS ── */
.lp-sec{padding:72px 5vw}
.lp-inner{max-width:1180px;margin:0 auto}
.lp-sec-head{text-align:center;margin-bottom:2.8rem}
.lp-badge{display:inline-block;font-size:.74rem;letter-spacing:.12em;text-transform:uppercase;color:var(--green);font-weight:700;margin-bottom:.6rem}
.lp-sec-title{font-size:clamp(1.7rem,3vw,2.5rem);font-weight:800;line-height:1.2}
.lp-sec-sub{color:var(--muted);font-size:1rem;margin-top:.8rem;max-width:60ch;margin-left:auto;margin-right:auto}

/* ── CATEGORIES ── */
.lp-cat-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:1.2rem}
.lp-cat-card{
  background:linear-gradient(135deg,#249E94,#1a7a6f);border-radius:var(--r);
  padding:1.4rem;display:flex;align-items:center;gap:1rem;cursor:pointer;
  text-decoration:none;color:#fff;transition:transform .2s,box-shadow .2s;
  box-shadow:0 4px 12px rgba(36,158,148,0.2);
}
.lp-cat-card:hover{transform:translateY(-4px);box-shadow:0 12px 36px rgba(36,158,148,0.3)}
.lp-cat-ic{width:50px;height:50px;border-radius:50%;background:rgba(255,255,255,.22);display:grid;place-items:center;font-size:1.45rem;flex-shrink:0}
.lp-cat-t{flex:1;min-width:0}
.lp-cat-en{color:#fff;font-size:.95rem;font-weight:700}
.lp-cat-ar{color:rgba(255,255,255,.78);font-size:.74rem;margin-top:.2rem;direction:rtl}
.lp-cat-arrow{width:28px;height:28px;border-radius:50%;background:rgba(255,255,255,.22);display:grid;place-items:center;color:#fff;font-size:.8rem;flex-shrink:0}

/* ── FEATURES ── */
.lp-gray{background:var(--bg)}
.lp-feat-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:1.2rem}
.lp-feat-card{background:var(--white);border-radius:var(--r);border:1px solid var(--border);padding:1.5rem;transition:transform .2s,box-shadow .2s,border-color .2s}
.lp-feat-card:hover{transform:translateY(-3px);box-shadow:0 8px 24px rgba(0,0,0,.07);border-color:transparent}
.lp-feat-icon{width:46px;height:46px;border-radius:12px;display:grid;place-items:center;font-size:1.25rem;margin-bottom:.9rem}
.lp-feat-card h3{font-size:.97rem;font-weight:700;margin-bottom:.4rem}
.lp-feat-card p{color:var(--muted);font-size:.87rem;line-height:1.65}

/* ── SCREENSHOTS ── */
.lp-shots{display:flex;gap:1.2rem;overflow-x:auto;padding:1rem 0 1.5rem;scrollbar-width:none}
.lp-shots::-webkit-scrollbar{display:none}
.lp-shot{flex-shrink:0;width:280px;border-radius:var(--r);overflow:hidden;border:1px solid var(--border);box-shadow:0 4px 14px rgba(0,0,0,.07);transition:transform .2s}
.lp-shot:hover{transform:scale(1.02)}
.lp-shot img{width:100%;display:block}

/* ── REVIEWS ── */
.lp-rev-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:1.2rem}
.lp-rev-card{background:var(--white);border-radius:var(--r);border:1px solid var(--border);padding:1.4rem}
.lp-rev-stars{color:#F5A623;font-size:1rem;margin-bottom:.6rem;letter-spacing:.1em}
.lp-rev-text{font-size:.9rem;line-height:1.65;color:var(--text);margin-bottom:.8rem}
.lp-rev-name{font-weight:700;font-size:.84rem;color:var(--muted)}

/* ── DOWNLOAD SECTION ── */
.lp-download{
  background:linear-gradient(135deg,#249E94,#1a7a6f);
  padding:80px 5vw;text-align:center;position:relative;overflow:hidden;
}
.lp-download::before,.lp-download::after{content:'';position:absolute;border-radius:50%;background:rgba(255,255,255,.07);pointer-events:none}
.lp-download::before{top:-80px;left:-80px;width:280px;height:280px}
.lp-download::after{bottom:-60px;right:-60px;width:240px;height:240px}
.lp-download h2{font-size:clamp(1.7rem,3vw,2.5rem);font-weight:800;color:#fff;margin-bottom:.8rem}
.lp-download p{color:rgba(255,255,255,.82);font-size:1rem;margin-bottom:2.5rem}
.lp-download-btns{display:flex;gap:1rem;justify-content:center;flex-wrap:wrap;position:relative;z-index:1}
.lp-store-btn{
  background:#fff;color:var(--text);border-radius:14px;padding:.85rem 1.8rem;
  display:inline-flex;align-items:center;gap:.9rem;text-decoration:none;
  font-weight:700;font-size:.95rem;min-width:180px;
  transition:transform .2s,box-shadow .2s;box-shadow:0 4px 14px rgba(0,0,0,.12);
}
.lp-store-btn:hover{transform:translateY(-3px);box-shadow:0 10px 30px rgba(0,0,0,0.2)}
.lp-store-sub{font-size:.62rem;font-weight:400;color:var(--muted);display:block;line-height:1}
.lp-store-name{font-size:.95rem;display:block;line-height:1.4}
.lp-download-note{color:rgba(255,255,255,.6);font-size:.82rem;margin-top:1.4rem;position:relative;z-index:1}

/* ── FOOTER ── */
.lp-footer{background:#111827;color:#9CA3AF;padding:2.5rem 5vw;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:1rem;font-size:.84rem}
.lp-footer-brand{font-weight:800;color:#fff;font-size:1rem}
.lp-footer-brand span{color:var(--green)}
.lp-footer-links{display:flex;gap:1.5rem;flex-wrap:wrap}
.lp-footer-links a{color:#9CA3AF;text-decoration:none;transition:color .2s}
.lp-footer-links a:hover{color:#fff}

/* ── REVEAL ── */
.lp-reveal{opacity:0;transform:translateY(22px);transition:opacity .55s ease,transform .55s ease}
.lp-reveal.in{opacity:1;transform:translateY(0)}

/* ── KEYFRAMES ── */
@keyframes lpUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
@keyframes lpFade{from{opacity:0}to{opacity:1}}
@keyframes lpFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}

/* ══════════════════════════════
   RESPONSIVE
══════════════════════════════ */
@media(max-width:880px){
  .lp-nav-links{display:none}
  .lp-burger{display:flex}
  .lp-hero{padding:88px 5vw 60px}
  .lp-hero-inner{grid-template-columns:1fr;gap:3rem;text-align:center}
  .lp-hero-desc{max-width:100%}
  .lp-hero-actions{justify-content:center}
  .lp-stats{justify-content:center}
  .lp-hero-ar{text-align:right}
  .lp-phone-wrap{margin-top:0}
  .lp-float-1{left:0;bottom:10px}
  .lp-float-2{right:0;top:30px}
}
@media(max-width:600px){
  .lp-hero{padding:80px 4vw 50px}
  .lp-hero-inner{gap:2.5rem}
  .lp-hero h1{font-size:2rem}
  .lp-hero-actions{flex-direction:column;align-items:center}
  .lp-hero-store-btn{width:100%;max-width:280px;justify-content:center}
  .lp-phone-frame{width:210px}
  .lp-float{font-size:.68rem;padding:.45rem .7rem}
  .lp-float-1{left:-5px}
  .lp-float-2{right:-5px}
  .lp-sec{padding:56px 4vw}
  .lp-cat-grid{grid-template-columns:1fr}
  .lp-feat-grid{grid-template-columns:1fr}
  .lp-rev-grid{grid-template-columns:1fr}
  .lp-download{padding:56px 4vw}
  .lp-download-btns{flex-direction:column;align-items:center}
  .lp-store-btn{width:100%;max-width:280px;justify-content:center}
  .lp-footer{flex-direction:column;text-align:center;padding:2rem 4vw}
  .lp-footer-links{justify-content:center}
  .lp-dl-btn{padding:.45rem 1rem;font-size:.82rem}
}
@media(max-width:380px){
  .lp-phone-frame{width:190px}
  .lp-float-1,.lp-float-2{display:none}
}
`;

/* ─────────── ICONS ─────────── */
function PlayIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M3.18 23.5a1.5 1.5 0 001.5.07l12.69-7.18-2.83-2.84L3.18 23.5zM20.5 10.3L17.44 8.6l-3.18 3.1 3.18 3.18 3.1-1.72a1.5 1.5 0 000-2.86zM1.5.49a1.5 1.5 0 00-.5 1.14v20.74c0 .46.2.88.5 1.14L13.56 11.7 1.5.49zM4.68.43l11.86 6.74-2.98 2.97L4.68.43z"/>
    </svg>
  );
}
function AppleIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 26" fill="currentColor">
      <path d="M18.5 13.5c-.03-3.1 2.53-4.6 2.64-4.67C19.56 6.4 17.17 6.1 16.3 6.08c-2.03-.21-3.97 1.2-5 1.2s-2.6-1.17-4.29-1.14C4.83 6.17 2.7 7.42 1.53 9.37-0.86 13.37.83 19.27 3.14 22.5c1.15 1.65 2.52 3.5 4.3 3.43 1.73-.07 2.38-1.12 4.47-1.12s2.67 1.12 4.47 1.08c1.86-.03 3.04-1.67 4.18-3.33 1.32-1.9 1.86-3.75 1.89-3.84-.04-.02-3.62-1.4-3.65-5.2zm-3.4-9.56c.95-1.17 1.6-2.77 1.42-4.4-1.38.06-3.06.93-4.05 2.08C11.54 2.63 10.73 4.27 10.94 5.87c1.53.12 3.1-.79 4.16-1.93z"/>
    </svg>
  );
}

/* ─────────── PHONE MOCKUP ─────────── */
function PhoneUI() {
  return (
    <div className="lp-phone-frame">
      <div className="lp-phone-screen">
        {/* Header */}
        <div className="lp-ph-header">
          <h3>Nursing Prometric Prep</h3>
          <p>استعد لامتحان برومترك بثقة</p>
        </div>

        {/* Body */}
        <div className="lp-ph-body">
          {/* Welcome Card */}
          <div className="lp-ph-welcome-card">
            <h4 className="lp-ph-welcome-title">مرحبا !</h4>
            <p className="lp-ph-welcome-text">وصلت إلى مرحلة مهمة في مسيرتك المهنية. ابدأ الآن وارتقِ بمعرفتك لاجتياز الامتحان بنجاح.</p>
          </div>

          {/* Category Label */}
          <h5 className="lp-ph-cat-label">اختر تخصصك</h5>

          {/* Category Cards */}
          <div className="lp-ph-categories">
            {categories.map(cat => (
              <div key={cat.en} className="lp-ph-category-card">
                <div className="lp-ph-cat-icon">{cat.icon}</div>
                <div className="lp-ph-cat-text">
                  <div className="lp-ph-cat-ar">{cat.ar}</div>
                  <div className="lp-ph-cat-en">{cat.en}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Buttons */}
          <div className="lp-ph-bottom-buttons">
            <button className="lp-ph-btn lp-ph-btn-primary">التواصل</button>
            <button className="lp-ph-btn lp-ph-btn-secondary">تطبيقات طبية</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── MAIN ─────────── */
export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const refs = useRef([]);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.lp-nav') && !e.target.closest('.lp-mobile-menu')) setMenuOpen(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    refs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const r = el => { if (el && !refs.current.includes(el)) refs.current.push(el); };

  return (
    <>
      <style>{css}</style>

      {/* ── NAV ── */}
      <nav className="lp-nav">
        <a href="#top" className="lp-brand">
          <img src={APP_ICON} alt="Nursing Prometric" />
          Nursing<span>Prometric</span>
        </a>
        <ul className="lp-nav-links">
          <li><a href="#categories">Categories</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#screenshots">Screenshots</a></li>
          <li><a href="/privacy-policy">Privacy</a></li>
        </ul>
        {/* "Download" in nav → scrolls to #download section */}
        <a href="#download" className="lp-dl-btn" style={{ display: 'flex' }}>
          <PlayIcon /> Download
        </a>
        <div onClick={() => setMenuOpen(o => !o)} style={{ display: 'none' }} className="lp-burger-wrap">
          <button className={`lp-burger${menuOpen ? ' open' : ''}`} aria-label="Toggle menu">
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div className={`lp-mobile-menu${menuOpen ? ' open' : ''}`}>
        <a href="#categories"  onClick={closeMenu}>Categories</a>
        <a href="#features"    onClick={closeMenu}>Features</a>
        <a href="#screenshots" onClick={closeMenu}>Screenshots</a>
        <a href="/privacy-policy" onClick={closeMenu}>Privacy</a>
        {/* Mobile download → scrolls to #download */}
        <a href="#download" className="lp-mobile-dl" onClick={closeMenu}>⬇ Download App</a>
      </div>

      {/* ── HERO ── */}
      <section className="lp-hero" id="top">
        <div className="lp-hero-inner">
          <div>
            <div className="lp-tag">🇸🇦 Saudi Prometric Certified Prep</div>
            <h1>Ace Your<br/><span>Nursing Prometric</span><br/>Exam</h1>
            <div className="lp-hero-ar">برومترك للتمريض — استعد للنجاح</div>
            <p className="lp-hero-desc">
              Prepare for the Saudi Prometric exam as a Nursing Specialist, Medical Assistant,
              Emergency Technician, or Lab Technician. Required for working in the Kingdom of Saudi Arabia.
            </p>

            {/* ── Both store buttons in hero ── */}
            <div className="lp-hero-actions">
              <a href={PLAY_URL} className="lp-hero-store-btn android" target="_blank" rel="noreferrer">
                <PlayIcon size={22} />
                <div>
                  <span className="lp-hero-store-sub">Get it on</span>
                  <span className="lp-hero-store-name">Google Play</span>
                </div>
              </a>
              <a href={APPLE_URL} className="lp-hero-store-btn apple" target="_blank" rel="noreferrer">
                <AppleIcon size={22} />
                <div>
                  <span className="lp-hero-store-sub">Download on the</span>
                  <span className="lp-hero-store-name">App Store</span>
                </div>
              </a>
            </div>

            <div className="lp-stats">
              <div>
                <div className="lp-stat-v" style={{ color: '#249E94' }}>10K+</div>
                <div className="lp-stat-l">Downloads</div>
              </div>
              <div>
                <div className="lp-stat-v" style={{ color: '#249E94' }}>4.8★</div>
                <div className="lp-stat-l">App Rating</div>
              </div>
              <div>
                <div className="lp-stat-v" style={{ color: '#249E94' }}>100%</div>
                <div className="lp-stat-l">Free to Use</div>
              </div>
            </div>
          </div>

          {/* Phone mockup on the right */}
          <div className="lp-phone-wrap">
            <PhoneUI />
            <div className="lp-float lp-float-1">
              <div className="lp-fdot" style={{ background: '#249E94' }} />
              <span>1000+ Questions</span>
            </div>
            <div className="lp-float lp-float-2">
              <div className="lp-fdot" style={{ background: '#249E94' }} />
              <span>Full Exam Prep</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── CATEGORIES ── */}
      <section className="lp-sec" id="categories">
        <div className="lp-inner">
          <div className="lp-sec-head">
            <div className="lp-badge lp-reveal" ref={r}>Exam Types</div>
            <h2 className="lp-sec-title lp-reveal" ref={r}>Choose Your Path</h2>
            <p className="lp-sec-sub lp-reveal" ref={r}>Specialized preparation for all Prometric exam categories in Saudi Arabia.</p>
          </div>
          <div className="lp-cat-grid">
            {categories.map(cat => (
              <a key={cat.en} href="#" className="lp-cat-card lp-reveal" ref={r} style={{ background: cat.gradient }}>
                <div className="lp-cat-ic">{cat.icon}</div>
                <div className="lp-cat-t">
                  <div className="lp-cat-en">{cat.en}</div>
                  <div className="lp-cat-ar">{cat.ar}</div>
                </div>
                <div className="lp-cat-arrow">→</div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="lp-sec lp-gray" id="features">
        <div className="lp-inner">
          <div className="lp-sec-head">
            <div className="lp-badge lp-reveal" ref={r}>What's Inside</div>
            <h2 className="lp-sec-title lp-reveal" ref={r}>Everything You Need to Pass</h2>
            <p className="lp-sec-sub lp-reveal" ref={r}>All the tools, resources, and practice content to walk into your exam with full confidence.</p>
          </div>
          <div className="lp-feat-grid">
            {features.map(f => (
              <div key={f.title} className="lp-feat-card lp-reveal" ref={r}>
                <div className="lp-feat-icon" style={{ background: `${f.color}18` }}>{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SCREENSHOTS ── */}
      <section className="lp-sec" id="screenshots">
        <div className="lp-inner">
          <div className="lp-sec-head">
            <div className="lp-badge lp-reveal" ref={r}>App Preview</div>
            <h2 className="lp-sec-title lp-reveal" ref={r}>See It in Action</h2>
          </div>
          <div className="lp-shots lp-reveal" ref={r}>
            {SCREENSHOTS.map((src, i) => (
              <div key={i} className="lp-shot">
                <img src={src} alt={`App screenshot ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section className="lp-sec lp-gray">
        <div className="lp-inner">
          <div className="lp-sec-head">
            <div className="lp-badge lp-reveal" ref={r}>User Reviews</div>
            <h2 className="lp-sec-title lp-reveal" ref={r}>What Our Users Say</h2>
          </div>
          <div className="lp-rev-grid">
            {reviews.map(rv => (
              <div key={rv.name} className="lp-rev-card lp-reveal" ref={r}>
                <div className="lp-rev-stars">{'★'.repeat(rv.stars)}</div>
                <p className="lp-rev-text">"{rv.text}"</p>
                <div className="lp-rev-name">— {rv.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DOWNLOAD SECTION ── */}
      <section className="lp-download" id="download">
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h2>Download the App Today</h2>
          <p>Available on Android and iOS. Free to download — trusted by 10,000+ medical professionals.</p>
          <div className="lp-download-btns">
            <a href={PLAY_URL} className="lp-store-btn" target="_blank" rel="noreferrer">
              <PlayIcon size={24} />
              <div>
                <span className="lp-store-sub">Get it on</span>
                <span className="lp-store-name">Google Play</span>
              </div>
            </a>
            <a href={APPLE_URL} className="lp-store-btn" target="_blank" rel="noreferrer">
              <AppleIcon size={24} />
              <div>
                <span className="lp-store-sub">Download on the</span>
                <span className="lp-store-name">App Store</span>
              </div>
            </a>
          </div>
          <p className="lp-download-note">✓ Free &nbsp;·&nbsp; ✓ Android &amp; iOS &nbsp;·&nbsp; ✓ Arabic &amp; English</p>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <div className="lp-footer-brand">Nursing<span>Prometric</span></div>
        <div className="lp-footer-links">
          <a href="#top">Home</a>
          <a href="#features">Features</a>
          <a href="#download">Download</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="https://www.facebook.com/nursingprometric994" target="_blank" rel="noreferrer">Contact</a>
        </div>
        <div>© 2025 NeoSanad. All rights reserved.</div>
      </footer>
 
      <style>{`
        @media(max-width:880px){
          .lp-dl-btn{ display:none !important }
          .lp-burger-wrap{ display:flex !important }
        }
      `}</style>
    </>
  );
}
